import { StyleSheet, Platform } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  cardStyle: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    marginTop: 34,
    paddingHorizontal: 17,
    paddingVertical: 15,
    borderRadius: 6,
    shadowColor: Colors.blackThree,
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.16,
    shadowRadius: 8,
    elevation: 4,
  }),
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  titleleftContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  title: {
    ...Fonts.type.bold,
    fontSize: Platform.OS === 'ios' ? 16.6 : 16,
    lineHeight: 22.9,
    marginBottom: 8.3,
  },
  description: {
    fontSize: Platform.OS === 'ios' ? 16.6 : 16,
    lineHeight: 18.7,
    marginBottom: 16.6,
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  buttonStyle: {
    ...Fonts.type.bold,
    height: 32,
    flex: 1,
  },
  textButtonStyle: {
    ...Fonts.type.bold,
    fontSize: Platform.OS === 'ios' ? 16.6 : 16,
  },
  primaryButtonStyle: {
    marginRight: 16.6,
    flex: 1,
  },
  statusDotStyle: {
    marginTop: 3,
    marginRight: 10,
  },
  toggleStyle: {
    margin: 0,
  },
});
